import { AudioItem } from './audio-item';

export class AudioSession {
  public description: string;
  public items: AudioItem[];
}
